import Icon from '@mdi/react';
import { mdiWeb } from '@mdi/js';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCallback, useMemo, useState } from 'react';
import { BaseButtonMenu } from '@mgm/common/components/base';
import { useAppDispatch } from '../hooks/useAppStore';
import { commonActions } from '../store/common/slice';

const LanguageSelect = () => {
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const [selectedLang, setSelectedLang] = useState(i18n.language);

  const changeLanguage = useCallback((lang: string) => {
    dispatch(commonActions.setSelectedLang(lang));
    setSelectedLang(lang);
    return i18n.changeLanguage(lang);
  }, [i18n]);

  const languageItems = useMemo(() => [
    {
      name: 'English',
      value: 'en',
      action: () => changeLanguage('en'),
      isSelected: selectedLang === 'en',
    },
    {
      name: 'Spanish',
      value: 'es',
      action: () => changeLanguage('es'),
      isSelected: selectedLang === 'es',
    },
  ], [changeLanguage, selectedLang]);

  return (
    <Box sx={{ marginX: { xs: 2, lg: 0 } }} display="flex" justifyContent="end">
      <BaseButtonMenu
        listProps={{
          items: languageItems,
          sx: {
            width: 'auto',
          },
          itemfontsize: 12,
        }}
        buttonProps={{
          sx: { minWidth: 'auto', padding: 0 },
          children: (
            <div id="language">
              <Icon path={mdiWeb} size={1} />
            </div>
          ),
        }}
      />
    </Box>
  );
};

export {
  LanguageSelect,
};
